import { Checkbox, DatePicker, Input, Select } from 'antd';
import { CustomDatePicker } from 'components/custom';
import dayjs from 'dayjs';
import { FormikProps, useFormik } from 'formik';
import { childrenTypes } from 'utils';
import { calculateAge } from 'utils/common_function';
import * as Yup from 'yup';
type ChildrenTableProps = {
  onClose: () => void;
  addChildren: boolean;
  data?: any;
  onDataChanged?: (data: any) => void;
  parentFormik?: FormikProps<any>;
};

const listOptions = [
  {
    label: 'Child',
    value: 'child',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

const ChildrenTable = ({
  onClose,
  addChildren,
  parentFormik,
}: ChildrenTableProps) => {
  const formSchema = Yup.object().shape({
    last_name: Yup.string().required(),
    first_name: Yup.string().required(),
    date_of_birth: Yup.string().required(),
    link: Yup.string().required(),
  });

  const formik = useFormik({
    initialValues: {
      link: 'child',
      last_name: '',
      first_name: '',
      date_of_birth: null,
      is_dependent: false,
    },
    // validationSchema: formSchema,
    onSubmit: (data) => {
      onClose();
      if (data?.date_of_birth === 'Invalid Date') data.date_of_birth = null;
      parentFormik.setFieldValue('children_dependents', [
        ...parentFormik?.values?.children_dependents,
        data,
      ]);
      resetForm();
    },
  });
  const { errors, resetForm } = formik;
  const deleteChildrenData = (index: number) => {
    const t = parentFormik?.values?.children_dependents.filter(
      (o: childrenTypes, i: number) => i !== index,
    );
    // parentFormik.values.children_dependents = t;
    parentFormik.setFieldValue?.('children_dependents', t);
  };
  // console.log(parentFormik.values.children_dependents);

  if (parentFormik?.values?.children_dependents?.length === 0 && !addChildren)
    return (
      <div style={{ marginLeft: '45%', marginTop: '10px', color: '#D1D1D1' }}>
        No item
      </div>
    );
  // console.log(parentFormik?.values?.children_dependents);

  return (
    <div>
      {parentFormik?.values?.children_dependents?.map(
        (item: childrenTypes, index: number) => (
          <div key={index}>
            <div
              style={{
                display: 'flex',
                width: '100%',
                gap: 10,
                marginTop: 15,
                paddingLeft: 40,
              }}
            >
              <div
                style={{
                  width: '12%',
                  justifyContent: 'center',
                  fontSize: '12px',
                  color: '#000',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {index + 1}
              </div>
              <div style={{ width: '16%' }}>
                <Select
                  options={listOptions}
                  value={item?.link}
                  style={{
                    borderRadius: 0,
                    border: '0.5px solid #407fdd',
                    width: '100%',
                    outline: 'none',
                    height: 30,
                    cursor: 'not-allowed',
                  }}
                  open={false}
                  className="children_dependents_select"
                />
              </div>
              <Input
                id="last_name"
                value={item.last_name}
                readOnly
                maxLength={100}
                style={{ width: '14%', borderRadius: 0 }}
                className="add_user_input_table"
              />
              <Input
                value={item.first_name}
                id="first_name"
                maxLength={100}
                readOnly
                style={{ width: '14%', borderRadius: 0 }}
                className="add_user_input_table"
              />

              <div
                style={{
                  width: '14%',
                }}
                className="edit_item_date_new"
              >
                <CustomDatePicker
                  disabledDate={(current) => {
                    return current && current > dayjs();
                  }}
                  name="date_of_birth"
                  title=""
                  height={30}
                  borderRadius="0px"
                  fontSize={12}
                  value={item.date_of_birth ? dayjs(item.date_of_birth) : null}
                  inputReadOnly
                  open={false}
                />
              </div>

              <Input
                value={
                  item.date_of_birth
                    ? calculateAge(
                        dayjs(item.date_of_birth).format('YYYY-MM-DD'),
                      )
                    : ''
                }
                id="age"
                readOnly
                style={{ width: '16%', borderRadius: 0 }}
                className="add_user_input_table"
              />
              <div
                style={{ paddingTop: 5, width: '3%' }}
                className="edit_item_checkbox"
              >
                <Checkbox
                  id="is_dependent"
                  checked={item.is_dependent}
                  style={{ marginLeft: '30px', width: '36px' }}
                />
              </div>
              <div
                style={{ display: 'flex', padding: 5, gap: 10, width: '5%' }}
              >
                <div>
                  <img
                    onClick={() => deleteChildrenData(index)}
                    style={{ cursor: 'pointer', height: '20px', width: '20px' }}
                    src="/icons/decline.svg"
                    alt="decline"
                  />
                </div>
              </div>
            </div>
          </div>
        ),
      )}
      {addChildren && (
        <form onSubmit={formik.handleSubmit}>
          <div
            style={{
              display: 'flex',
              width: '100%',
              gap: 10,
              marginTop: 15,
              paddingLeft: 40,
            }}
          >
            <div
              style={{
                width: '12%',
                justifyContent: 'center',
                fontSize: '12px',
                color: '#000',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {parentFormik?.values?.children_dependents?.length === 0
                ? 1
                : parentFormik?.values?.children_dependents?.length + 1}
            </div>

            <div style={{ width: '16%' }}>
              <select
                style={{
                  borderRadius: 0,
                  border: '0.5px solid #407fdd',
                  width: '100%',
                  height: 30,
                  outline: 'none',
                  paddingLeft: '7px',
                  fontSize: '12px',
                  color: '#000',
                }}
                className="children_dependents_select"
                onChange={formik.handleChange}
                id="link"
              >
                <option value="child">Child</option>
                <option value="other">Other</option>
              </select>
            </div>
            <Input
              id="last_name"
              style={{
                width: '14%',
                borderColor: (errors?.last_name as string) ? 'red' : '',
                borderRadius: 0,
              }}
              onChange={formik.handleChange}
              className="add_user_input_table"
              maxLength={100}
            />
            <Input
              id="first_name"
              onChange={formik.handleChange}
              style={{
                width: '14%',
                borderColor: (errors?.first_name as string) ? 'red' : '',
                borderRadius: 0,
              }}
              className="add_user_input_table"
              maxLength={100}
            />
            <div
              style={{
                width: '14%',
                borderColor: (errors?.date_of_birth as string) && 'red',
              }}
              className="edit_item_date_new"
            >
              <CustomDatePicker
                name="date_of_birth"
                disabledDate={(current) => {
                  return current && current > dayjs();
                }}
                onChange={(e) => {
                  formik.setFieldValue(
                    'date_of_birth',
                    dayjs(e).format('YYYY-MM-DD'),
                  );
                }}
                title=""
                height={30}
                borderRadius="0px"
                fontSize={12}
                error={errors?.date_of_birth}
              />
            </div>
            {/* <input
              id="date_of_birth"
              onChange={formik.handleChange}
              style={{ width: '14%' }}
              className="add_user_input_table"
            /> */}
            <input
              disabled={true}
              value={
                formik.values?.date_of_birth
                  ? calculateAge(
                      dayjs(formik.values?.date_of_birth).format('YYYY-MM-DD'),
                    )
                  : ''
              }
              id="age"
              onChange={formik.handleChange}
              style={{ width: '16%' }}
              className="add_user_input_table"
            />

            <span
              style={{ paddingTop: 5, width: '3%' }}
              className="edit_item_checkbox"
            >
              <Checkbox
                id="is_dependent"
                onChange={formik.handleChange}
                style={{ marginLeft: '30px', width: '36px' }}
              />
            </span>
            <div style={{ display: 'flex', padding: 5, gap: 10, width: '5%' }}>
              <div
                onClick={() => formik.handleSubmit()}
                style={{ padding: 0, border: 'none', background: 'white' }}
              >
                <img
                  style={{ cursor: 'pointer', height: '20px', width: '20px' }}
                  src="/icons/accept.svg"
                  alt="accept"
                />
              </div>
              <div>
                <img
                  onClick={() => {
                    resetForm();
                    onClose();
                  }}
                  style={{ cursor: 'pointer', height: '20px', width: '20px' }}
                  src="/icons/decline.svg"
                  alt="decline"
                />
              </div>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default ChildrenTable;
